import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { JobFile } from "@/types";

/**
 * This hook is used to remove a job file in the job files query
 * without refetching the entire query.
 */
export const useRemoveJobFile = () => {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  return ({ jobFileId }: { jobFileId: number }) => {
    queryClient.setQueryData(
      ["files", currentCompanyId, currentJobId],
      (cachedData: JobFile[]) => {
        return cachedData.filter(
          (cachedJobFile: JobFile) => cachedJobFile.id !== jobFileId,
        );
      },
    );
  };
};
